import { Navigate, useParams } from 'react-router-dom';

import { createRoute, PATHS } from '@src/core/router/paths';

import {
  automationDrawerSearch,
  CREATE_VALUE,
} from '../hooks/use-automation-drawer';

function ToAutomationDrawer({
  value,
  edit = false,
}: {
  value: string;
  edit?: boolean;
}) {
  return (
    <Navigate
      to={{
        pathname: createRoute(PATHS.CONVERSATIONS_AUTOMATION),
        search: automationDrawerSearch(value, { edit }),
      }}
      replace
    />
  );
}

/** Old `/automations/:id` links open the detail drawer on the Automation tab,
 * which replaced the standalone detail page. */
export function AutomationDetailRedirect() {
  const { automationId } = useParams<{ automationId: string }>();
  return <ToAutomationDrawer value={automationId ?? ''} />;
}

/** Old `/automations/new` links open the New Automation wizard, which
 * replaced the full-page editor. */
export function AutomationNewRedirect() {
  return <ToAutomationDrawer value={CREATE_VALUE} />;
}

/** Old `/automations/:id/edit` links open the Edit Automation wizard, which
 * replaced the full-page editor. */
export function AutomationEditRedirect() {
  const { automationId } = useParams<{ automationId: string }>();
  return (
    <ToAutomationDrawer
      value={automationId ?? ''}
      edit
    />
  );
}
